import { ClientModel } from "./ClientModel";
import { TokenValidationMode } from "./TokenValidationMode";

export class ServerSettingsModel {
    serverUrl: KnockoutObservable<string> = ko.observable(null).extend({
        required: true,
        pattern: {
            onlyIf: () => PRODUCTION === true,
            message: 'Url must start from "https\:\/\/',
            params: '^https\:\/\/\/*'
        }
    });
    apiSecret: KnockoutObservable<string> = ko.observable(null).extend({required: true});
    domainAutoLoginEnabled: KnockoutObservable<boolean> = ko.observable(false);
    applyHostAsOrigin: KnockoutObservable<boolean> = ko.observable(false);
    hideArmsLoginUI: KnockoutObservable<boolean> = ko.observable(false);
    supportIISWindowsAuthenticationEnabled: KnockoutObservable<boolean> = ko.observable(false);
    isTwoFactorAuthEnabled: KnockoutObservable<boolean> = ko.observable(false);
    twoFactorAuthConfigDelay: KnockoutObservable<number> = ko.observable(null).extend({ required: true, min: 1, max: 14 });

    _tokenValidationMode: KnockoutObservable<TokenValidationMode> = ko.observable(TokenValidationMode.Local);
    tokenValidationMode: KnockoutComputed<string> = ko.pureComputed({
        read: () => this._tokenValidationMode().toString(),
        write: (value: string) => this._tokenValidationMode(+value)
    });

    clients: KnockoutObservableArray<ClientModel> = ko.observableArray([]);
}
